import React, { useState } from "react";
import '../styles/Empcustomerassi.css';
import axios from "axios";
import { useEffect } from "react";
import { ChevronRight, Search } from "lucide-react";
import { Link } from "react-router-dom";
import ResultsPagination from "../components/ResultsPagination";

export default function Empcustomerassi() {
  const [search, setSearch] = useState("");
  const [customerFilter, setCustomerFilter] = useState("All");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [empSearch, setEmpSearch] = useState("");
  const [selectedEmps, setSelectedEmps] = useState([]);

  const [customers, setCustomers] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const token = localStorage.getItem("token");

  const axiosConfig = {
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    }
  };

  useEffect(() => {
    fetchCustomers();
    fetchEmployees();
  }, []);

  useEffect(() => {
    setActivePage(1);
  }, [search, customerFilter]);

  const fetchCustomers = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/api/customers`,
        axiosConfig
      );

      const customerData = res.data?.customers || [];

      setCustomers(
        Array.isArray(customerData)
          ? customerData.map(c => ({
            id: c.id,
            customer: c.full_name,
            company: "-",
            status: c.status === true ? "Active" : c.status === false ? "Inactive" : "-",
            assigned: c.assigned_employees || []
          }))
          : []
      );

    } catch (err) {
      console.error("FETCH CUSTOMERS ERROR:", err);
      setCustomers([]);
    }
  };

  const customerOptions = [
    "All",
    ...Array.from(
      new Set(
        customers.map(c => c.customer)
          .filter(Boolean)
      )
    ).sort()
  ];

  const fetchEmployees = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/api/employees`,
        axiosConfig
      );

      setEmployees(
        Array.isArray(res.data)
          ? res.data
          : []
      );

    } catch (err) {
      console.error("FETCH EMPLOYEES ERROR:", err);
    }
  };

  const filtered = (customers || []).filter((row) => {
    const text = search.toLowerCase();

    const matchSearch =
      String(row.customer || "").toLowerCase().includes(text) ||
      String(row.company || "").toLowerCase().includes(text) ||
      String(row.status || "").toLowerCase().includes(text) ||
      (row.assigned || [])
        .map(emp => emp.name)
        .join(" ")
        .toLowerCase()
        .includes(text);

    const matchFilter =
      customerFilter === "All" || row.customer === customerFilter;

    return matchSearch && matchFilter;
  });

  const startIndex = (activePage - 1) * perPage;
  const paginatedData = filtered.slice(startIndex, startIndex + perPage);
  const totalPages = Math.ceil(filtered.length / perPage);

  const openModal = (row) => {
    setSelectedRow(row);
    setSelectedEmps((row.assigned || []).map(emp => emp._id));
    setEmpSearch("");
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedRow(null);
  };

  const toggleEmp = (empId) => {
    setSelectedEmps((prevSelected) => {
      if (prevSelected.includes(empId)) {
        return prevSelected.filter((id) => id !== empId);
      }
      return [...prevSelected, empId];
    });
  };

  const saveAssignment = async () => {
    try {
      if (!selectedRow?.id) {
        alert("Invalid customer selected");
        return;
      }

      if (!Array.isArray(selectedEmps) || selectedEmps.length === 0) {
        alert("Please select at least one employee");
        return;
      }

      const payload = {
        customerId: selectedRow.id,
        employeeIds: [...new Set(selectedEmps)]
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/api/assign-customer`,
        payload,
        axiosConfig
      );

      if (response?.data?.success) {
        await fetchCustomers();
        closeModal();
        alert("Customer assigned successfully!");
      }

    } catch (err) {
      console.error("SAVE ASSIGNMENT ERROR:", err);
      alert(err?.response?.data?.message || "Failed to save assignment");
    }
  };

  const filteredEmps = employees.filter((e) =>
    (e.fullName || "").toLowerCase().includes(empSearch.toLowerCase())
  );

  const half = Math.ceil(filteredEmps.length / 2);
  const leftCol = filteredEmps.slice(0, half);
  const rightCol = filteredEmps.slice(half);

  return (
    <div>
      <nav
        aria-label="breadcrumb"
        style={{
          "--bs-breadcrumb-divider": "''",
        }}
      >
        <ol
          className="breadcrumb d-flex align-items-center mb-0"
          style={{ fontSize: "14px" }}
        >
          <li className="breadcrumb-item d-flex align-items-center">
            <Link to="/" className="text-decoration-none text-secondary">
              Home
            </Link>
            <ChevronRight size={16} className="mx-1 text-secondary" />
          </li>

          <li className="breadcrumb-item d-flex align-items-center">
            <Link
              to="/admin"
              className="text-decoration-none text-secondary"
            >
              Administration
            </Link>
            <ChevronRight size={16} className="mx-1 text-secondary" />
          </li>

          <li
            className="breadcrumb-item fw-semibold"
            style={{ color: "#2F7A87" }}
          >
            Employee-Customer Assignments
          </li>
        </ol>
      </nav>

      <div className="eca-page">
        <div className="eca-header-row">
          <div>
            <h1 className="eca-title">Employee-Customer Assignment</h1>
            <p className="eca-subtitle">Assign employees to manage customer tenders and operations.</p>
          </div>
        </div>

        <div className="eca-filter-card">
          <div style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            gap: '20px',
            flexWrap: 'wrap'
          }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flex: 1,
                minWidth: "250px",
                maxWidth: "420px",
                border:
                  "1px solid rgba(209, 213, 219, 1)",
                borderRadius: "38px",
                padding: "4px 8px 4px 12px",
                background: "#fff",
              }}
            >
              <Search
                size={16}
                color="#6c757d"
                style={{ flexShrink: 0 }}
              />

              <input
                type="text"
                placeholder="Search Customers"
                aria-label="Search customers"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  border: "none",
                  boxShadow: "none",
                  padding: "4px 0",
                  fontSize: "14px",
                  background: "transparent",
                  outline: "none",
                  width: "100%",
                }}
              />

              <button
                type="button"
                style={{
                  border: "none",
                  borderRadius: "50%",
                  width: "36px",
                  height: "36px",
                  backgroundColor:
                    "#2F7F8F",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  cursor: "pointer",
                }}
              >
                <Search
                  size={16}
                  color="#fff"
                />
              </button>
            </div>

            <div className="eca-filter-wrap" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              marginLeft: 'auto'
            }}>
              <label className="eca-filter-label" style={{
                fontSize: '14px',
                fontWeight: '500',
                color: '#333',
                whiteSpace: 'nowrap'
              }}>
                Customer:
              </label>
              <div className="eca-select-wrap" style={{ position: 'relative' }}>
                <select
                  className="eca-select"
                  value={customerFilter}
                  onChange={(e) => setCustomerFilter(e.target.value)}
                  style={{
                    padding: '10px 36px 10px 16px',
                    borderRadius: '50px',
                    border: '1px solid #ddd',
                    fontSize: '14px',
                    backgroundColor: '#fff',
                    appearance: 'none',
                    cursor: 'pointer',
                    outline: 'none',
                    minWidth: '150px'
                  }}
                >
                  {customerOptions.map((c) => (
                    <option key={c} value={c}>{c}</option>
                  ))}
                </select>
                <svg className="eca-select-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{
                  position: 'absolute',
                  right: '14px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none'
                }}>
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </div>
            </div>
          </div>

          <table className="eca-table eca-table-wrap border rounded-circle">
            <thead>
              <tr>
                <th>Customer</th>
                <th style={{ textAlign: "center" }}>Company</th>
                <th style={{ textAlign: "center" }}>Assigned Employees</th>
                <th style={{ textAlign: "center" }}>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((row) => (
                <tr key={row.id}>
                  <td>{row.customer}</td>
                  <td style={{ textAlign: "center" }}>{row.company || "-"}</td>
                  <td style={{ textAlign: "center" }}>
                    {row.assigned && row.assigned.length > 0 ? (
                      <>
                        {row.assigned.slice(0, 2).map(emp => emp.name).join(", ")}
                        {row.assigned.length > 2 && (
                          <span style={{ color: "#6b7280" }}>
                            {" "}+{row.assigned.length - 2}
                          </span>
                        )}
                      </>
                    ) : "-"}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {row.status === "Active" ? (
                      <span
                        style={{
                          backgroundColor: "rgb(47, 127, 143)",
                          color: "#fff",
                          padding: "2px 10px",
                          borderRadius: "50px",
                          fontSize: "12px",
                          fontWeight: "500",
                          display: "inline-block",
                        }}
                      >
                        {row.status}
                      </span>
                    ) : row.status === "Inactive" ? (
                      <span
                        style={{
                          backgroundColor: "#f3f4f6",
                          color: "#4b5563",
                          padding: "2px 10px",
                          borderRadius: "50px",
                          fontSize: "12px",
                          fontWeight: "500",
                          display: "inline-block",
                        }}
                      >
                        {row.status}
                      </span>
                    ) : (
                      row.status
                    )}
                  </td>
                  <td>
                    <button className="eca-manage-btn" onClick={() => openModal(row)}>
                      Manage
                    </button>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr>
                  <td colSpan="5" className="eca-empty">No records found.</td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="d-flex justify-content-end w-100">
            <ResultsPagination
              activePage={activePage}
              setActivePage={setActivePage}
              perPage={perPage}
              setPerPage={setPerPage}
              totalPages={totalPages}
              perPageOptions={[5, 10, 20, 50]}
            />
          </div>
        </div>

        {modalOpen && selectedRow && (
          <div className="eca-overlay" onClick={closeModal}>
            <div className="eca-modal" onClick={(e) => e.stopPropagation()}>
              <div className="eca-modal-header">
                <h2 className="eca-modal-title">Employee Assignment</h2>
                <button className="eca-modal-close" onClick={closeModal}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 6L6 18M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="eca-modal-info">
                <div className="eca-modal-info-block">
                  <span className="eca-modal-info-label">Customer</span>
                  <span className="eca-modal-info-value">{selectedRow.customer}</span>
                </div>
                <div className="eca-modal-info-block">
                  <span className="eca-modal-info-label">Company</span>
                  <span className="eca-modal-info-value">{selectedRow.company}</span>
                </div>
              </div>

              <p className="eca-modal-section-title">Assign Employees</p>
              <hr className="eca-modal-divider" />

              <div className="eca-modal-search-wrap">
                <svg className="eca-modal-search-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8" />
                  <path d="M21 21l-4.35-4.35" />
                </svg>
                <input
                  className="eca-modal-search-input"
                  type="text"
                  placeholder=""
                  value={empSearch}
                  onChange={(e) => setEmpSearch(e.target.value)}
                />
                <button className="eca-modal-search-btn">
                  <img src="/images/button.svg" alt="Search" className="eca-modal-search-btn-img" />
                </button>
              </div>

              <p className="eca-modal-hint">Number of assigned customers shown in bracket</p>

              <div className="eca-modal-emp-grid">
                <div className="eca-modal-emp-col">
                  {leftCol.map((emp, i) => (
                    <label key={`l-${i}`} className="eca-modal-check-label">
                      <input
                        type="checkbox"
                        className="eca-modal-checkbox"
                        checked={selectedEmps.includes(emp._id)}
                        onChange={() => toggleEmp(emp._id)}
                      />
                      <span className="eca-modal-check-text">
                        {emp.fullName}
                      </span>
                    </label>
                  ))}
                </div>
                <div className="eca-modal-emp-col">
                  {rightCol.map((emp, i) => (
                    <label key={`r-${i}`} className="eca-modal-check-label">
                      <input
                        type="checkbox"
                        className="eca-modal-checkbox"
                        checked={selectedEmps.includes(emp._id)}
                        onChange={() => toggleEmp(emp._id)}
                      />
                      <span className="eca-modal-check-text">{emp.fullName}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="eca-modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
                <button 
                  className="eca-assign-btn" 
                  onClick={saveAssignment}
                  style={{
                    backgroundColor: "#2F7F8F",
                    color: "#fff",
                    border: "none",
                    padding: "8px 24px",
                    borderRadius: "50px",
                    fontWeight: "500",
                    fontSize: "14px",
                    cursor: "pointer",
                    transition: "background-color 0.2s"
                  }}
                >
                  Assign
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}